import {Action} from "@ngrx/store";

export const LOAD_BACKUP_LIST: string = '[backup] Load Backup list';
export const LOAD_BACKUP_LIST_SUCCESS: string = '[backup] Load Backup list success';
export const LOAD_BACKUP_LIST_FAIL: string = '[backup] Load Backup list fail';

export class LoadBackupList implements Action {

  readonly type: string = LOAD_BACKUP_LIST;
  constructor(public payload: number) {}

}

export class LoadBackupListSuccess implements Action {

  readonly type: string = LOAD_BACKUP_LIST_SUCCESS;
  constructor(public payload: {
    [id: string]: any
  }) {}

}

export class LoadBackupListFail implements Action {

  readonly type: string = LOAD_BACKUP_LIST_FAIL;
  constructor(public payload: string) {}

}


export type BackupListAction = LoadBackupList | LoadBackupListSuccess | LoadBackupListFail;
